import { queryStringify } from '@utils'
import { createRequestHelper } from '@utils/swr'
import { type CampaignAvailableCouponsRequest } from '../types/apiRequest'
import { type CampaignAvailableCouponsResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['campaignAvailableCoupons'], CampaignAvailableCouponsResponse, CampaignAvailableCouponsRequest>({
  client: 'fortune',
  key: (params) => {
    const { campaign_code, merchant_id, project_code, manual_input_coupon_ids } = params || {}
    if (!campaign_code) {
      console.warn('[useApiCampaignAvailableCoupons] campaign_code is required!')
      return null
    }
    return `/campaigns/${campaign_code}/coupons/available_coupons?${queryStringify({ merchant_id, project_code, manual_input_coupon_ids }, { skipNull: true })}`
  },
  isImmutable: true,
})

export const useApiCampaignAvailableCoupons = useRequest
